import map from "lodash/fp/map";
import remove from "lodash/fp/remove";
import assign from "lodash/fp/assign";

class StationsPageTransform {
  constructor() {
    "ngInject";

    // NOTE: name is used for (user roles)
    this.item = {
      title: "Station",
      state: "station",
      name: "station",
    };

    this.fields = [
      { title: "Name", name: "name", isSortable: true },
      { title: "District", name: "district" },
    ];

    this.filters = [
      {
        name: "district",
        title: "District",
        icon: "place",
        resource: "District",
      },
      {
        name: "search",
        title: "Search",
        icon: "search",
        isSearch: true,
        resource: "Station",
        state: "station",
        size: 25,
      },
      {
        name: "is_dynamic",
        title: "Dynamic",
        icon: "directions_car",
        list: "routeType",
      },
      {
        name: "private_bus_request",
        title: "Private Bus Request",
        icon: "airport_shuttle",
        list: "isPrivateBusReq",
      },
    ];

    this.addOptions = {
      title: "Add New Station",
      icon: "add",
      fields: [
        {
          name: "name_i18n",
          title: "Name",
          type: "text",
          isI18nText: true,
          isRequired: true,
        },
        {
          resource: "District",
          name: "district",
          isResource: true,
          title: "District",
          isRequired: true,
        },
        {
          name: "address_i18n",
          title: "Address",
          type: "text",
          isI18nText: true,
          isRequired: true,
        },
        { name: "note", title: "Note", isTextarea: true, isRequired: false },
        { name: "loc", title: "Location", isLocation: true, isRequired: true },
      ],
    };
  }

  justify(data) {
    const getSource = (item) => {
      item = assign({ _id: item._id }, item._source);
      item.name = item.note ? item.name + " - " + item.note : item.name;

      return item;
    };

    return map(getSource)(data);
  }

  justifyPoints(data) {
    data = this.justify(data);
    const hasNoLocation = (s) => !(s.loc && s.loc.coordinates);

    return remove(hasNoLocation)(data);
  }
}

export default StationsPageTransform;



// WEBPACK FOOTER //
// ./src/pages/stations/stations.transforms.js